import React, { useEffect, useState } from 'react'

interface EMDGAccordionProps {
    header: string;
    expanded: boolean;
    children: React.ReactNode;
    onOpen?: ()=>void
}

const EMDGAccordion = (props: EMDGAccordionProps) => {
  const [expanded, setExpanded] = useState<boolean>(props.expanded)

  const ExpandOrCollapse = () => {
    console.log(`Expanded currebt:${expanded}`)
    const newValue: boolean = !expanded
    console.log(`new value${newValue}`)
    setExpanded(newValue)
    console.log(`Expanded after click:${expanded}`)
    if (props.onOpen && typeof props.onOpen === 'function') {
      console.log('called before call back')
      props.onOpen()
    }
  }

  return (

    <section className="emdg-accordion">
      <button
        className={expanded ? 'emdg-accordion__title emdg-accordion--open' : 'emdg-accordion__title emdg-accordion--closed'}
        onClick={() => ExpandOrCollapse()}
      >
        {props.header}
      </button>
      {
                expanded && (
                <div id="accordion1">
                  <div className="emdg-accordion__body-wrapper">
                    {props.children}
                  </div>
                </div>
                )
            }

    </section>

  )
}

export default EMDGAccordion
